<script>
import compoment from '@/components/draggable/CustomComponents/Input/DInputEditor'
export default {
  name: 'DTitleEditor',
  extends: compoment
}
</script>
